import React from "react";
import PropTypes from "prop-types";
import { I18n } from "@aws-amplify/core";
import { get } from "lodash";

import Grid from "@material-ui/core/Grid";
import MessageDialog from "../../Common/MessageDialog";
import DetailsContainer from "../../Common/DetailsContainer";
import ProfileViewMatched from "../../Profiles/ProfileView/ProfileViewMatched";
import CorrectConfirmValue from "../CorrectConfirmValue/CorrectConfirmValue";
//import OverrideDialogNew from "../OverrideDialogNew";
import OverrideDialog from "../OverrideDialog";
import CapturedPhotosContainer from "../CapturedPhotosContainer";
import ProfileLink from "../../Common/ProfileLink";
import CustomButton from "../../Common/CustomButton";
import images from "../../../assets/img/images";

import { getContextPhotosWithRoi } from "../../../utils/detectionDetails";
import { isUnknownProfile } from "../../../utils/profile";
import { formatDate } from "../../../utils/date";
import { getOcrLprConfirmationCorrection } from "../../../utils/event";
import { fetchPut } from '../../../api/fetch';

import {
  CONTEXT,
  CONTEXT_LPR,
  CONTEXT_OCR,
  OCR,
  LPR,
  truck,
  trailer,
  container,
} from "../../../constants/common";

import colors from "../../../assets/style/colors";

const LogDetailsVehicle = (props) => {
  const { refreshDetectionEventGroup, tabs, onRemovingTab } = props;
  const { log, lov, detectionEventGroup, dacId } = props.details;
  const [photoDetails, setPhotoDetails] = React.useState(null);
  const [capturedPhotos, setCapturedPhotos] = React.useState([]);
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    let photos = [];
    let photosNameSet = new Set();

    // Context photos
    props.details.contextPhotos.forEach((img) => {
      let newPhoto = getOcrLprConfirmationCorrection(
        {
          url: img.url,
          type: CONTEXT,
          values: [],
          matched: false,
        },
        detectionEventGroup
      );
      if (!photosNameSet.has(newPhoto.url)) {
        photosNameSet.add(newPhoto.url);
        photos.push(newPhoto);
      }
    });

    // Context photos from LPR cropped photos
    getContextPhotosWithRoi([props.details.lpr]).forEach((img) => {
      let newPhoto = getOcrLprConfirmationCorrection(
        {
          url: img.contextImage,
          type: CONTEXT_LPR,
          values: [],
          matched: false,
          roiOverlay: img.roiOverlay,
        },
        detectionEventGroup
      );
      if (!photosNameSet.has(newPhoto.url)) {
        photosNameSet.add(newPhoto.url);
        photos.push(newPhoto);
      }
    });

    // Context photos from OCR cropped photos
    getContextPhotosWithRoi([props.details.ocr]).forEach((img) => {
      let newPhoto = getOcrLprConfirmationCorrection(
        {
          url: img.contextImage,
          type: CONTEXT_OCR,
          values: [],
          matched: false,
          roiOverlay: img.roiOverlay,
        },
        detectionEventGroup
      );
      if (!photosNameSet.has(newPhoto.url)) {
        photosNameSet.add(newPhoto.url);
        photos.push(newPhoto);
      }
    });

    // LPR cropped photos
    props.details.lpr.forEach((rec) => {
      let newPhoto = getOcrLprConfirmationCorrection(
        {
          url: rec.croppedImage,
          type: LPR,
          values: [rec.text],
          matched: isMatch([rec.profile]),
          //roiOverlay: [rec.roiOverlay]
        },
        detectionEventGroup
      );
      if (!photosNameSet.has(newPhoto.url)) {
        photosNameSet.add(newPhoto.url);
        photos.push(newPhoto);
      }
    });

    // OCR cropped photos
    props.details.ocr.forEach((rec) => {
      let newPhoto = getOcrLprConfirmationCorrection(
        {
          url: rec.croppedImage,
          type: OCR,
          values: rec.values,
          matched: isMatch(rec.profiles),
          //roiOverlay: [rec.roiOverlay]
        },
        detectionEventGroup
      );
      if (!photosNameSet.has(newPhoto.url)) {
        photosNameSet.add(newPhoto.url);
        photos.push(newPhoto);
      }
    });

    setCapturedPhotos(photos);

    // Update selected photo if set
    if (photoDetails) {
      let updatedPhotoDetails = photos.filter(
        (p) => get(p, ["url"]) === get(photoDetails, ["url"])
      );
      if (updatedPhotoDetails && updatedPhotoDetails.length > 0) {
        setPhotoDetails(updatedPhotoDetails[0]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    detectionEventGroup,
    props.details.contextPhotos,
    props.details.lpr,
    props.details.ocr,
  ]);

  const isMatch = (profiles) => {
    let match = false;
    if (!get(log, ["profile"]) || !profiles) {
      return match;
    }
    profiles.forEach((p) => {
      if (
        p &&
        !isUnknownProfile(p.id) &&
        p.id === get(log, ["profile", "id"])
      ) {
        match = true;
      }
    });
    return match;
  };

  return (
    <>
      <CorrectConfirmValue
        section={props.section}
        open={photoDetails !== null}
        initialValue={photoDetails}
        close={() => setPhotoDetails(null)}
        photos={capturedPhotos}
        profileType={props.type === truck ? 2 : 3}
        profile={get(log, ["profile"])}
        detectionEventGroup={detectionEventGroup}
        refreshDetectionEventGroup={refreshDetectionEventGroup}
        reloadEventGroupAndFocusElement={refreshDetectionEventGroup}
        dacId={dacId}
        tabs={tabs}
      />
      <Grid
        container
        direction="column"
        alignItems="stretch"
        style={{ height: "-webkit-fill-available" }}
        wrap="nowrap"
      >
        {get(props, ["details", "override"]) && (
          <Grid
            item
            style={{
              textAlign: "right",
              paddingRight: "15px",
              fontSize: "0.875em",
              color: colors.black54,
            }}
          >
            {`${I18n.get("site_overridenBy")} ${get(props, [
              "details",
              "override",
              "overriden_by",
            ])}, ${formatDate(
              get(props, ["details", "override", "created_on"])
            )}`}
          </Grid>
        )}
        <Grid item style={{ height: "30px", marginBottom: "20px" }}>
          <Grid container>
            <Grid item xs={4} />
            <ProfileLink
              profile={get(log, ["profile"])}
              overriden={get(props, ["details", "override"])}
              type={get(props, ["type"])}
              score={get(props, ["details", "lukeIndex"])}
            />
            <Grid
              item
              xs={4}
              style={{ textAlign: "right", paddingRight: "10px" }}
            >
              {/* <OverrideDialogNew
                profileType={props.type}
                currentProfile={log.profile || {}}
                details={props.details}
                language={props.language}
                addNote={props.addNote}
                photos={capturedPhotos}
                tabs={tabs}
              /> */}
              <CustomButton
                onClick={() => setOpen(true)}
                startIcon={<img src={images.removeIcon} />}
              ><></></CustomButton>
              <MessageDialog
                open={open}
                message={I18n.get("profile_remove")}
                isEvent={true}
                onClose={async (flag) => {
                  if (flag) {
                    let eventGroupId = get(log, ["id"]);
                    await fetchPut(`event_groups/${eventGroupId}`, {
                      active: false,
                      source: "historical",
                    });
                    onRemovingTab();
                  }
                  setOpen(false);
                }}
              />
              <OverrideDialog
                profileType={props.type}
                currentProfile={get(log, ["profile"]) || {}}
                details={props.details}
                language={props.language}
                addNote={props.addNote}
                photos={capturedPhotos}
                tabs={tabs}
                lov={lov}
                log={props.log}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item style={{ marginBottom: "20px", width: "100%" }}>
          <CapturedPhotosContainer
            photos={capturedPhotos}
            onClickPhoto={(element) => setPhotoDetails(element)}
          />
        </Grid>
        {get(log, ["profile", "id"]) && !isUnknownProfile(log.profile.id) && (
          <Grid item>
            <DetailsContainer title={I18n.get("site_matchedProfile")}>
              <ProfileViewMatched
                profileType={props.type === truck ? 2 : 3}
                profile={get(log, ["profile"]) || {}}
                lov={lov}
                photos={get(log, ["profile"]) ? log.profile.images : []}
                disable={{ containerPadding: true, topBar: true }}
              />
            </DetailsContainer>
          </Grid>
        )}
        {props.powerUserMode && (
          <>
            <Grid item xs></Grid>
            <Grid
              item
              style={{
                textAlign: "right",
                fontSize: "0.875em",
                color: colors.black38,
                paddingRight: "10px",
              }}
            >
              {I18n.get("site_eventGroupId") + " "}
              <span style={{ fontStyle: "italic" }}>
                {props.details.detectionId}
              </span>
            </Grid>
          </>
        )}
      </Grid>
    </>
  );
};

LogDetailsVehicle.propTypes = {
  type: PropTypes.oneOf([truck, trailer, container]).isRequired,
  language: PropTypes.string.isRequired,
  refreshDetectionEventGroup: PropTypes.func.isRequired,
  tabs: PropTypes.object,
};

export default LogDetailsVehicle;
